/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import M_logo from "../../assets/main logo M.png";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import axios from "axios";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DocumentTitle from "../../utils/DocumentTitle";
const SignUp = () => {
  DocumentTitle("Mangas.IO translator");
  const [signedUp, setSignedUp] = useState(false);
  const isLogedin = false; // Not used, placeholder for future login check

  // useEffect(() => {
  //     if (localStorage.getItem("login_token")) {
  //         navigate('/series');
  //         setIsLogedIn(true);
  //     }
  // }, []);

  // show and hide password
  let [showHidePW, setShowHidePW] = useState(false);
  const showAndHidePW = () => {
    setShowHidePW(!showHidePW);
  };
  // end

  // on submit
  const [emailIsEmpty, setEmailIsEmpty] = useState(false);
  const [lastNameEmpty, setLastNameEmpty] = useState(false);
  const [passwordIsEmpty, setPasswordIsEmpty] = useState(false);

  const formOnSubmit = async (e) => {
    e.preventDefault();
    let credentials = new FormData(e.currentTarget);
    let email = credentials.get("email");
    let firstName = credentials.get("First Name");
    let lastName = credentials.get("Last Name");
    let nom_utilisateur = firstName ? firstName + " " + lastName : lastName;
    let password = credentials.get("mot_de_passe");

    if (email === "") {
      setEmailIsEmpty(true);
    } else {
      setEmailIsEmpty(false);
    }
    if (lastName === "") {
      setLastNameEmpty(true);
    } else {
      setEmailIsEmpty(false);
    }
    if (password === "") {
      setPasswordIsEmpty(true);
    } else {
      setPasswordIsEmpty(false);
    }

    if (email !== "" && password !== "" && lastName !== "") {
      const signUpData = {
        email: email,
        nom_utilisateur: nom_utilisateur,
        mot_de_passe: password,
        role: "Traducteur",
      };
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_HOST_API}/api/auth/signup`,
          signUpData
        );
        console.log("Sending signup data : ", signUpData);
        if (res.status === 201) {
          setSignedUp(true);
          toast.success("Your account has been created. You may now login");
          console.log("signed up");
        }
      } catch (error) {
        console.error("Error : ", error.message);
      }
    }
  };

  if (!isLogedin) {
    return (
      <div>
        <div className="login_container">
          <div className="left_side">
            <div className="img_M">
              <img src={M_logo} alt="MangasIO Logo" />
            </div>
            <div className="welcome_text">
              <h1>
                Hey 👋🏼 <br />
                Welcome to Mangas.io Translator
              </h1>
            </div>
            <div className="subtext">
              <p>
                {/* We are lorem ipsum team dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. */}
              </p>
            </div>
          </div>
          <div className="right_side">
            <div className="login_section">
              {!signedUp && (
                <>
                  <h2>Sign Up</h2>
                  <form
                    action=""
                    className="login_form"
                    onSubmit={formOnSubmit}
                  >
                    <input
                      type="text"
                      name="email"
                      id="email"
                      placeholder={
                        emailIsEmpty ? "Email is required" : "Email Adress"
                      }
                      style={
                        emailIsEmpty
                          ? { border: "1px solid red" }
                          : { border: "1px solid #DCDCDC" }
                      }
                    />
                    <div className="input_block">
                      <input
                        type="text"
                        name="First Name"
                        id="First Name"
                        placeholder="First Name"
                      />
                      <input
                        type="text"
                        name="Last Name"
                        id="Last Name"
                        placeholder={
                          lastNameEmpty ? "Last name is required" : "Last name"
                        }
                        style={
                          lastNameEmpty
                            ? { border: "1px solid red" }
                            : { border: "1px solid #DCDCDC" }
                        }
                      />
                    </div>
                    <div className="password_block">
                      <input
                        type={showHidePW ? "text" : "password"}
                        name="mot_de_passe"
                        id="mot_de_passe"
                        placeholder={
                          passwordIsEmpty ? "Password is required" : "Password"
                        }
                        style={
                          passwordIsEmpty
                            ? { border: "1px solid red" }
                            : { border: "1px solid #DCDCDC" }
                        }
                      />
                      {!showHidePW && (
                        <span className="hide_password" onClick={showAndHidePW}>
                          <FaEyeSlash />
                        </span>
                      )}
                      {showHidePW && (
                        <span className="hide_password" onClick={showAndHidePW}>
                          <FaEye />
                        </span>
                      )}
                    </div>
                    <button type="submit" id="login_btn">
                      Sign Up
                    </button>
                  </form>
                </>
              )}
              {signedUp && (
                <div className="signup_success">
                  <div className="signup_valid">
                    <FaCheck />
                  </div>
                  <h2>Thank You !</h2>
                  <p>Your account has been created successfully</p>
                  <Link className="login_btn" to="/login">
                    Login
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
};

export default SignUp;
